"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var ng2_bs3_modal_1 = require("@bhtp-fork/ng2-bs3-modal/ng2-bs3-modal");
var modal_service_1 = require("./modal.service");
var MessageModalComponent = (function () {
    function MessageModalComponent(modalService) {
        this.modalService = modalService;
    }
    MessageModalComponent.prototype.ngOnInit = function () {
        this.onCloseModal();
        this.modalService.registerMessageModalComponent(this);
    };
    MessageModalComponent.prototype.ngOnDestroy = function () {
        this.onCloseModal();
        this.modalService.clearMessageModalComponent();
    };
    MessageModalComponent.prototype.open = function (title, message) {
        this.title = title;
        this.message = message;
        if (!this.modal.visible) {
            this.modal.open();
        }
    };
    MessageModalComponent.prototype.onCloseModal = function () {
        if (this.modal) {
            this.modal.close();
        }
    };
    return MessageModalComponent;
}());
__decorate([
    core_1.ViewChild('messageModal'),
    __metadata("design:type", ng2_bs3_modal_1.ModalComponent)
], MessageModalComponent.prototype, "modal", void 0);
MessageModalComponent = __decorate([
    core_1.Component({
        selector: 'message-modal',
        template: "<modal #messageModal class=\"panel-primary\">     <div class=\"modal-heading\" style=\"border-top-left-radius: 4px; border-top-right-radius: 4px;\">         <modal-header [show-close]=\"true\">             <h4 class=\"modal-title\">{{title}}</h4>         </modal-header>     </div>     <modal-body>         {{message}}     </modal-body>     <modal-footer>         <button type=\"button\" class=\"btn btn-default btn-cust\" (click)=\"onCloseModal($event)\">OKAY</button>     </modal-footer> </modal>",
    }),
    __metadata("design:paramtypes", [modal_service_1.ModalService])
], MessageModalComponent);
exports.MessageModalComponent = MessageModalComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/modals/message-modal.component.js